import { Link } from "react-router-dom";
import { Store, QrCode, UtensilsCrossed, Monitor, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import OjentLogo from "@/components/OjentLogo";

const POINTS = [
  { icon: Store, title: "Your own restaurant", desc: "Sign up in minutes. Your menu, tables, staff, and sales stay private." },
  { icon: UtensilsCrossed, title: "POS + kitchen + waiters", desc: "Billing, kitchen tickets, approvals, and floor service in one login." },
  { icon: QrCode, title: "Guest links that work", desc: "Scan & order, kiosk, token TV, website, and feedback — each on your URL." },
  { icon: Monitor, title: "Ready for many outlets", desc: "Every restaurant gets a slug like /r/my-cafe. No shared catalog." },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <header className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
        <OjentLogo markSize={40} />
        <div className="flex items-center gap-2">
          <Link to="/login" className="text-sm font-medium text-neutral-600 px-3 py-2">Log in</Link>
          <Link to="/signup">
            <Button className="bg-[var(--kul-primary)] hover:bg-[var(--kul-primary-hover)] text-white h-10">
              Onboard restaurant
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 pt-10 pb-20">
        <div className="max-w-2xl">
          <OjentLogo markSize={56} className="mb-6" />
          <p className="text-xs uppercase tracking-[0.18em] text-[var(--kul-primary)] font-semibold">Restaurant OS</p>
          <h1 className="font-display text-4xl sm:text-6xl font-800 tracking-tight mt-3 leading-[1.05]">
            Onboard your restaurant. Start taking orders today.
          </h1>
          <p className="text-neutral-600 mt-5 text-lg leading-relaxed">
            Restaurants sign up themselves, set up menu and tables, then use POS, kitchen, waiters, UPI, and guest QR pages. Each outlet is isolated.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/signup">
              <Button className="h-12 px-6 bg-[var(--kul-primary)] hover:bg-[var(--kul-primary-hover)] text-white font-semibold">
                Create restaurant account <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </Link>
            <Link to="/login">
              <Button variant="outline" className="h-12 px-6">Staff / owner login</Button>
            </Link>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mt-16">
          {POINTS.map((p) => (
            <div key={p.title} className="kul-card p-5">
              <p.icon className="w-6 h-6 text-[var(--kul-primary)]" />
              <div className="font-semibold mt-3">{p.title}</div>
              <p className="text-sm text-neutral-500 mt-1">{p.desc}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
